import { useState, useEffect, useRef } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Toaster, toast } from 'react-hot-toast';
import { useForm } from "react-hook-form";
import {GETUSERS,REGISTER,UPDATEUSER, UPLOAD_VENDORFORMAT_CSV,GETPAYMENTREPORTCONDENSED,PayVendor,PayMiscVendor,ViewVendorMisc } from "../../api/apiConfig";
import { apiGet, apiPost } from "../../utils/services";
import { Button, FormControlLabel, Grid, IconButton, Paper, Radio, RadioGroup, Stack, TextField , Table, TableBody, TableCell, TableHead, TableRow, InputAdornment, Divider, TableContainer, ButtonGroup,} from "@mui/material";
import moment from "moment/moment";
import { FaBackspace, FaBan, FaEdit, FaEllipsisH, FaInfoCircle, FaPercent, FaPercentage, FaPoundSign, FaTimesCircle } from "react-icons/fa";
import Popup from "../../components/atoms/Popup/Popup";
import Modal from "react-responsive-modal";
import { AnalyticsService } from "../../utils/Analytics";
import { BiBook, BiCheckCircle, BiEdit, BiPlus, BiSearch, BiSend, BiTrash, BiUpload } from "react-icons/bi";
import AvatarBox from "../../components/atoms/AvatarBox/AvatarBox";
import { SecondaryButton, Spinner, Title } from "../../components/atoms";
import { useMediaQuery } from "react-responsive";
import ImageUploading from "react-images-uploading";
import ImageResizer from "../../components/organisms/ImageResizer/ImageResizer";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Container } from "../../components/DragDropCard/DragDropCard";
import { moneyFormat } from "../../components/atoms/Helper/helper";



const Merchants = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const videoInputRef = useRef();
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })
  const isAdmin =localStorage.getItem("roleId")=="1"
    const [isLoading, setIsLoading] = useState(false);
    const [merchants, setMerchants] = useState();
    const [viewMiscModal, setViewMiscModal] = useState(null);
    const [confirmationModal, setConfirmationModal] = useState(null);
    const [confirmationMiscModal, setConfirmationMiscModal] = useState(null);
    const [paymentReports, setPaymentReports] = useState([]);
    const [miscPayments, setMiscPayments] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(false);
    const[searchItem,setSearchItem]=useState('')
    const [popup, setPopup] = useState({})
    const [state, setState] = useState({
        productCategories: [],
        images: [],
    });

    const {
      images,
    } = state;

    const [_merchant, set_merchant] = useState(null);
    const [page, setPage] = useState(1);
    const [open, setOpen] = useState(false);
    const onOpenModal = () => setOpen(true);
    const onCloseModal = () => setOpen(false);
    const openPopup = (name, e,data) => {
        setPopup({ ...popup, [name]: popup[name] ? null : e.currentTarget,data:data })
    }
    const closePopup = () => {
        setPopup({})
    }
    const updateState = (data) => setState((prevState) => ({ ...prevState, ...data }));

    useEffect(() => {
      getUserList();
      getUserPaymentReports();
      getVendorMiscPayments();
    }, []);

    const getUserList = async () => {
      setIsLoading(true);
      const res = await apiGet(GETUSERS);
      if (res) {
        setMerchants(res)
      }
      setIsLoading(false);
    };

    const getUserPaymentReports = async () => {
      setIsLoading(true);
      const res = await apiGet(GETPAYMENTREPORTCONDENSED);
      if (res) {
        setPaymentReports(res)
      }
      setIsLoading(false);
    };

    const getVendorMiscPayments = async () => {
      setIsLoading(true);
      const res = await apiGet(ViewVendorMisc);
      if (res) {
        setMiscPayments(res.data)
      }
      setIsLoading(false);
    };

   function getAddress(d){
      return d.street+' '+d.city+' '+d.countryCode
   }


   function pageSwitcher(){
      switch (page){
        case 1: return ViewMerchantPage();
        case 2: return AddMerchantPage();
        case 3: return EditMerchantPage();
      }

   }
   

   


    return (
        <div className="tabPanelCls h-100" >
            <Toaster />
            {pageSwitcher()}

        </div>
    )

  function boolean_(d){
    return d?<BiCheckCircle size={"24px"} color="green"/>:<FaTimesCircle size={"24px"} color="red"/>
  }

  function getPendingPayments(id){
      var payment=paymentReports.filter(x=>x.userId==id)[0]
      if(payment==null) return 0;
      return payment.netPayment
  }

  function ViewMerchantPage(){
    const edit =(data)=>{
      if(data.OperatingAddress==null){
        data.OperatingAddress=data.street + " " + data.city + " " + data.postalCode + " " + data.countryCode
      }
      set_merchant(data);
      setPage(3)
    }
    
      return (
        <div className="dispatchTimer" style={{ position: 'relative', textAlign: 'center' }}>
        <div style={{ width: '100%', background: 'white', marginTop: '10px' }}>
            <div className="">
                <Stack direction={{xs: 'column', md: 'row'}} spacing={3}>
                    <h2 style={{display:'flex'}}><IconButton>
                      <a className={'j'} style={{textDecoration:'none',color:'red'}} href={'/Settings'}><FaBackspace/></a>
                    </IconButton>Merchant Management</h2>
                   
                </Stack>
            </div>
          

            {isAdmin &&<Stack direction={'row'} spacing={2} justifyContent="space-between" className=' space-bottom space-top'>
              
            <TextField 
              size="small"
              type={"search"}
              
                InputProps={{ startAdornment:(
                <InputAdornment position="start">
                  <BiSearch sx={{color: "#8D0C1"}}/>
                </InputAdornment>
              )}} onChange={(data)=> setSearchItem(data.target.value) }    placeholder={'Search by Merchant'} />
              <div>
                  {/* <Button  className="space-right2"
                variant="outlined" startIcon={<BiUpload sx={{color: "#1d9649"}}/>}>Upload Merchants</Button> */}
                <Button startIcon={!isTabletOrMobile &&<BiPlus/>} onClick={() => setPage(2)} variant="contained">{isTabletOrMobile?'New Merchant':'Add New Merchant'}</Button>
                
              </div>
            </Stack>}
          </div> 

          {isAdmin &&
            <Paper>
              <TableContainer sx={{ overflowX: "auto"}}>
                <Table >
                <TableHead className='tableHead' >
                  <TableRow>
                    <TableCell><span className=' bold'>Name</span></TableCell>
                    <TableCell><span className=' bold'>Email</span></TableCell>
                    <TableCell><span className=' bold'>Address</span></TableCell>
                    <TableCell ><span className=' bold'>Phone</span></TableCell>
                    <TableCell ><span className=' bold'>Stripe Connected</span></TableCell>
                    <TableCell ><span className=' bold'>Auto-accept</span></TableCell>
                    <TableCell ><span className=' bold'>Dispatch Time Set</span></TableCell>
                    <TableCell ><span className=' bold'>Xero Integration</span></TableCell>
                    <TableCell ><span className=' bold'>Product Uploaded</span></TableCell>
                    <TableCell ><span className=' bold'>Pending Payments</span></TableCell>
                    <TableCell ><span className=' bold'>Last Misc Payments</span></TableCell>



                    <TableCell ><span className=' bold'>TCS Fee</span></TableCell>
                    <TableCell ><span className=' bold'>Actions</span></TableCell>
                  </TableRow>
                </TableHead>
                  <TableBody>
                    {merchants?.filter(x=>x.name?.toLowerCase().includes(searchItem?.toLowerCase())).map((data,index)=>{
                      return(
                        <TableRow key={index}>
                          <TableCell>
                            <Stack direction={"row"} spacing={1} alignItems="center" >
                              <AvatarBox  name={data?.name} showname={true}/>
                            </Stack>
                          </TableCell>
                          <TableCell><span>{data.email}</span></TableCell>
                          <TableCell><span>{getAddress(data)}</span></TableCell>
                          <TableCell><span>{data.phone}</span></TableCell>
                          <TableCell><span>{boolean_(data.stripeConnectedId!=null)}</span></TableCell>
                          <TableCell><span>{boolean_(data.autoAcceptOrders)}</span></TableCell>
                          <TableCell><span>{boolean_(data.dispatchTimeCompleted)}</span></TableCell>
                          <TableCell><span>{boolean_(data.xeroAccountingActivated)}</span></TableCell>
                          <TableCell><span>{boolean_(data.productUploaded)}</span></TableCell>
                          <TableCell><span>{moneyFormat(getPendingPayments(data.id))}</span></TableCell>
                          <TableCell><span>{moneyFormat((data.lastMiscPayment))}</span></TableCell>
                          <TableCell><span>{data.tcsCommission==null?'20%':data.tcsCommission+"%"}</span></TableCell>
                          <TableCell>
                            <IconButton onClick={(e) => openPopup('more', e,data)}><FaEllipsisH/></IconButton> 
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
              </Table>
              </TableContainer>
            </Paper>
          }
            
      <Popup close={closePopup}  target={popup.more}>
        <div>
          <ButtonGroup  orientation="vertical" variant="outlined" spacing={2}>
            <Button onClick={()=>{edit(popup.data);closePopup()}}  startIcon={<BiEdit fontSize='small' />}>Edit</Button>
            <Button onClick={()=>{setConfirmationModal(popup.data);closePopup()}}  startIcon={<FaPoundSign fontSize='small' />}>Settle Payout</Button>
            <Button onClick={()=>{setConfirmationMiscModal(popup.data);closePopup()}}  startIcon={<FaPoundSign fontSize='small' />}>Pay Miscelleneous</Button>
            <Button onClick={()=>{setViewMiscModal(popup.data);closePopup()}}  startIcon={<BiBook fontSize='small' />}>View Miscelleneous Payments</Button>
          </ButtonGroup>
        </div>
      </Popup>
      {ConfirmationModal()}
      {ConfirmationMiscModal()}
      {ViewMiscModal_()}

        </div>
      )

  }

  function AddMerchantPage() {
    const onImageChange = async (imageList, addUpdateIndex) => {
      setIsImageLoading(true);
      let images = [];
      for (let index = 0; index < imageList.length; index++){
        const img = imageList[index];
        if (!img.image) {
          let newImage = new Image();
          newImage.src = URL.createObjectURL(img.file);
          images = await loadImage(imageList, img, newImage, images);
        } else {
          images.push(img);
        }
      };
      updateState({ images: images });
      setIsImageLoading(false);
    };
    const loadImage = async (imageList, img, newImage, imageArray) => {
      return new Promise((resolve) => {
        newImage.onload = async () => {
          let megaPixels = (newImage.width * newImage.height) / 1000000;
    
          if (imageList.length > 0) {
            if (megaPixels > 19) {
              let resizedImage = new Image();
              
              console.log("Image is above 20MP...");
              let fileToResize = img.file;
              let maxWidth = 3000;
              let maxHeight = 4000;
    
              const imageResizer = ImageResizer(fileToResize, maxWidth, maxHeight);
              try {
                const resizedImageBlob = await imageResizer.resizeImage();
                resizedImage.src = URL.createObjectURL(resizedImageBlob);
                newImage.width = maxHeight;
                newImage.height = maxHeight;
                console.log("size = w", newImage.width, " h", newImage.height, "blob", resizedImageBlob);
                console.log("Image Resized", resizedImageBlob, "----", newImage);
    
                const resizedImageUrl = await LoadResizedImage(resizedImageBlob, resizedImage);
                
    
                imageArray.push({
                  src: resizedImage.src,
                  imageName: img.file.name,
                  imageType: img.file.type,
                  imageb64: resizedImageUrl.split(";")[1].split(",")[1],
                });
              } catch (error) {
                console.error('Error resizing image:', error);
              }
            } else {
              imageArray.push({             
                src: newImage.src,
                imageName: img.file.name,
                imageType: img.file.type,
                imageb64: img.data_url.split(";")[1].split(",")[1],
                image : img
              });
            }
          }
    
          resolve(imageArray);
        };
      });
    };
    const LoadResizedImage = async (resizedImageBlob, resizedImage) =>{
      return new Promise((resolve) => {
        resizedImage.onload = async () => {
          console.log("resized width ", resizedImage.width, " height ", resizedImage.height);
    
          const dataURL = await new Promise((innerResolve) => {
            const reader = new FileReader();
            reader.onloadend = () => innerResolve(reader.result);
            reader.readAsDataURL(resizedImageBlob);
          });
    
          resolve(dataURL);
        };
      });
    };
    const onImageChangeUpdate = (imageList) => {
      updateState({ images: imageList });
    };
    const onImageRemove = (deleteIndex) => {
      const allImages = images;
      allImages.splice(deleteIndex, 1);
      updateState({ images: allImages });
    
    };
      const onSubmit = async (e) => {
          setIsLoading(true);
          const data={
            Name:e.Name,
            Email:e.Email,
            City:e.City,
            CountryCode:e.CountryCode,
            Street:e.Street,
            Password:e.Password,
            PostalCode:e.PostalCode,
            StateOrProvinceCode:e.StateOrProvinceCode,
            Phone:e.Phone,
            Images:images,
            TCSCommission:e.TCSCommission,
            BrandEmail:e.BrandEmail,
            BrandName:e.BrandName,
            CatelogUrl:e.Catalogue,
            YearOfBusiness:e.Year,
            OperatingAddress:e.OperatingAddress,
          }
          try {
          const res = await apiPost(REGISTER, data );
          if (res) {
              AnalyticsService.logEvent("MERCHANT_ADDED_SUCCESSFULLY");
              toast.success("Merchant added successfully");
              setOpen(false);
              setPage(1)
              await getUserList();
          }
        } catch (error) {
          console.log(error);
          toast.error("An error occurred while adding the merchant: "+error?.message);
          };
          setIsLoading(false);
      };
      return (
          <div className="dispatchTimer" style={{ position: 'relative' }}>
                <div style={{ width: '100%', background: 'white', marginTop: '10px' }}>
                    <div className="">
                        <Stack direction={{xs: 'column', md: 'row'}} spacing={3}>
                            <h2 style={{display:'flex'}}><IconButton  onClick={()=>setPage(1)}>
                             <FaBackspace/>
                            </IconButton>Add Merchant</h2>
                           
                        </Stack>
                    </div>
                  
              <Paper className="padding" style={{width:!isTabletOrMobile &&'800px',margin:'auto'}}>
                      <div>
                      <form onSubmit={handleSubmit(onSubmit)}>

                        <Grid container columnSpacing={3} rowSpacing={3}>




                          <Grid item md={6} mdOffset={6}>
                            <label >Brand Logo</label>
                            <Stack direction={'row'} spacing={0} className="center box">
                             {images.length === 0 && <ImageUploading
                                data-testid="file-uploader"
                                value={images}
                                onChange={onImageChange}
                                dataURLKey="data_url"
                                maxFileSize={157286400}
                                acceptType={["png", "jpg", "jpeg"]}
                                multiple
                                maxNumber={1}
                                
                              >
                                {({
                                  imageList,
                                  onImageUpload,
                                  dragProps,
                                  isDragging,
                                  errors,
                                }) => (
                                  <>
                                    <div style={{height:'100px'}} className="imageGrid center2" {...dragProps}>
                                      {isDragging && ""}
                                      <SecondaryButton
                                        text={"Upload Brand Logo"}
                                        className="addFormCls"
                                        onClick={onImageUpload}
                                        disabled={images.length === 1 ? true : false}
                                      />
                                    </div>
                                    {errors && (
                                      <div>
                                        {errors.maxFileSize && (
                                          <span className="errorTexCls">
                                            Selected image size exceed 10MB
                                          </span>
                                        )}
                                        {errors.resolution && (
                                          <span className="errorTexCls">
                                            Selected image resolution exceed 20MP
                                          </span>
                                        )}
                                        {errors.maxNumber && (
                                          <span className="errorTexCls">
                                            Number of selected images exceed max (10) allowed
                                            images.
                                          </span>
                                        )}
                                        {errors.acceptType && (
                                          <span className="errorTexCls">
                                            Selected file type is not allowed.
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </>
                                )}
                              </ImageUploading>}

                              <DndProvider backend={HTML5Backend}>
                                <Container
                                  dragData={state.images}
                                  onImageRemove={onImageRemove}
                                  onImageChangeUpdate={onImageChangeUpdate}
                                />
                              </DndProvider>
                            </Stack>
                           

                           
                          </Grid>
                          <Grid item md={6} xs={6}>

                          </Grid>

                        <Grid item md={6} xs={6}>
                          <label >Full Name</label>
                          <TextField fullWidth size="small" type="text"  {...register("Name",{ required: true})}
                            placeholder="Enter first name" />
                            {errors.firstName &&  <p className="error">fullname is required</p>}
                        </Grid>
                        <Grid item md={6} xs={6}>
                          <label >Brand Name</label>
                          <TextField fullWidth size="small" type="text"  {...register("BrandName",{ required: true})}
                            placeholder="Enter BrandName" />
                            {errors.BrandName &&  <p className="error">BrandName is required</p>}
                        </Grid>

                        <Grid item md={6} xs={6}>
                          <label className='space-top'>Phone</label>
                          <TextField fullWidth size="small" type="phone"  {...register("Phone",{ required: true})}
                            placeholder="Enter Phone (Optional)" />
                        </Grid>

                        <Grid item md={6} xs={6}>
                          <label>Account Email</label>
                          <TextField fullWidth size="small" type="email"   {...register("Email",{ required: true})}
                            placeholder="Enter Email Address" />
                          {errors.Email &&  <p className="error">Email is required</p>}
                        </Grid>

                        <Grid item md={6} xs={6}>
                          <label>Other Notification Email</label>
                          <TextField fullWidth size="small" type="text"   {...register("BrandEmail")}
                            placeholder="Enter Email Address (Optional)" />
                        </Grid>

                        <Grid item md={6} xs={6}>
                          <label>TCS Commission</label>
                          <TextField 
                          InputProps={{ 
                            inputProps: { min: 0, max: 100 },
                            startAdornment:(
                              <InputAdornment position="start">
                               <FaPercent sx={{color: "#8D0C1"}}/>
                              </InputAdornment>)
                          }}
                           defaultValue={20}  fullWidth size="small" type="number"  {...register("TCSCommission")}
                            placeholder="Enter TCS Commission " />
                        </Grid>
                        
                        <Grid item md={6} xs={6}>
                          <label className='space-top'>Street</label>
                          <TextField fullWidth size="small" type="text"  {...register("Street",{ required: true})}
                            placeholder="Enter Street name" />
                            {errors.Street &&  <p className="error">Street is required</p>}
                        </Grid>

                        <Grid item md={6} xs={6}>
                          <label className='space-top'>City</label>
                          <TextField fullWidth size="small" type="text"  {...register("City",{ required: true})}
                            placeholder="Enter City" />
                            {errors.city &&  <p className="error">City is required</p>}
                        </Grid>

                        <Grid item md={6} xs={6}>
                          <label className='space-top'>Country Code</label>
                          <TextField fullWidth size="small" type="text"  {...register("CountryCode")}
                            placeholder="Enter Country Code" />
                            {errors.CountryCode &&  <p className="error">Country Code is required</p>}
                        </Grid>

                        <Grid item md={6} xs={6}>
                          <label className='space-top'>Postal Code</label>
                          <TextField fullWidth size="small" type="text"  {...register("PostalCode")}
                            placeholder="Enter Postal Code" />
                            {errors.PostalCode &&  <p className="error">Postal Code is required</p>}
                        </Grid>

                        <Grid item md={6} xs={6}>
                          <label className='space-top'>{isTabletOrMobile?"State Code":"State Or Province Code"}</label>
                          <TextField fullWidth size="small" type="text"  {...register("StateOrProvinceCode")}
                            placeholder="Enter State Or Province Code" />
                            {errors.StateOrProvinceCode &&  <p className="error">State Or Province Code is required</p>}
                        </Grid>
                        {/* <Grid item md={12} xs={12}>
                          <label className='space-top'>Operating Address</label>
                          <TextField fullWidth size="small" type="text"  {...register("OperatingAddress", { required: false })}
                            placeholder="Leave empty if same with brand address" />
                        </Grid> */}

                        <Grid item md={6} xs={6}>
                          <label className='space-top'>Catalogue URL</label>
                          <TextField fullWidth size="small" type="text"  {...register("Catalogue")}
                            placeholder="Catalogue URL (Optional)" />
                        </Grid>

                        <Grid item md={6} xs={6}>
                          <label className='space-top'>Year of Business</label>
                          <TextField fullWidth size="small" type="text"  {...register("Year")}
                            placeholder="Year of Business (Optional)" />
                        </Grid>
                        </Grid>
                        <div className='push-right space-top'>
                          <Button type="submit" variant="contained" 
                           startIcon={ isLoading? <Spinner
                            size={20}
                            color="red"
                            loading={isLoading}
                            // style={{ marginTop: marginTop }}
                        />:<BiPlus sx={{color:'white'}}/>} >
                              Add Merchant
                          </Button>
                        </div>
                        </form>
                      </div>
              </Paper>
            </div>
          </div>
      )
  }

  function EditMerchantPage() {
    const update =(key,value)=>{
      set_merchant({..._merchant,[key]:value})
    }
    
    const onSubmit = async (e) => {
        setIsLoading(true);
        const data ={
          Name:_merchant.name,
          Email:_merchant.email,
          City:_merchant.city,
          CountryCode:_merchant.countryCode,
          Street:_merchant.street,
          PostalCode:_merchant.postalCode,
          StateOrProvinceCode:_merchant.stateOrProvinceCode,
          City2:_merchant.city2,
          CountryCode2:_merchant.countryCode2,
          ShippingFee:_merchant.shippingFee,
          Street2:_merchant.street2,
          PostalCode2:_merchant.postalCode2,
          StateOrProvinceCode2:_merchant.stateOrProvinceCode2,
          Password:"Password12*",
          Phone:_merchant.phone,
          TCSCommission:_merchant.tcsCommission,
          Id:_merchant.id,
          BrandEmail:_merchant.brandEmail,
          BrandName:_merchant.brandName,
          CatelogUrl:_merchant.catelogUrl,
          YearOfBusiness:_merchant.yearOfBusiness,
          // OperatingAddress:_merchant.OperatingAddress,
        }
        const res = await apiPost(UPDATEUSER, data );

        console.log("RES",res)
        if (res) {
            AnalyticsService.logEvent("MERCHANT_UPDATED_SUCCESSFULLY");
            toast.success("Merchant Updated");
            //set_merchant(null)
            await getUserList();
        }else{
          setIsLoading(false);
        }
        setIsLoading(false);
    };
    return (
      <div className="dispatchTimer" style={{ position: 'relative',}}>
      <div style={{ width: '100%', background: 'white', marginTop: '10px' }}>
          <div className="">
              <Stack direction={{xs: 'column', md: 'row'}} spacing={3}>
              <h2 style={{display:'flex'}}><IconButton  onClick={()=>setPage(1)}>
                             <FaBackspace/>
                  </IconButton>Update Merchant</h2>
                 
              </Stack>
          </div>
            <Paper className="padding" style={{width:!isTabletOrMobile &&'800px',margin:'auto'}}>
                    <div>
                    <form onSubmit={handleSubmit(onSubmit)}>

                      <Grid container  columnSpacing={3} rowSpacing={3}>

                      <Grid item md={6} xs={6}>
                        <label >Full Name</label>
                        <TextField disabled fullWidth size="small" type="text" value={_merchant?.name} onChange={(e)=>update("name",e.target.value)} 
                          placeholder="Enter first name" />
                          {errors.firstName &&  <p className="error">fullname is required</p>}
                      </Grid>
                      <Grid item md={6} xs={6}>
                          <label >Brand Name</label>
                          <TextField fullWidth size="small" type="text"  value={_merchant?.brandName} onChange={(e)=>update("brandName",e.target.value)} 
                            placeholder="Enter BrandName" />
                            {errors.BrandName &&  <p className="error">BrandName is required</p>}
                        </Grid>


                      <Grid item md={6} xs={6}>
                        <label className='space-top'>Phone</label>
                        <TextField fullWidth size="small" type="phone"  value={_merchant?.phone} onChange={(e)=>update("phone",e.target.value)} 
                          placeholder="Enter Phone (Optional)" />
                      </Grid>

                      <Grid item md={6} xs={6}>
                        <label>Email</label>
                        <TextField disabled fullWidth size="small" type="email"    value={_merchant?.email} onChange={(e)=>update("email",e.target.value)} 
                          placeholder="Enter Email Address" />
                        {errors.Email &&  <p className="error">Email is required</p>}
                      </Grid>

                      <Grid item md={6} xs={6}>
                        <label>Other Notification Email</label>
                        <TextField fullWidth size="small" type="text"   value={_merchant?.brandEmail} onChange={(e)=>update("brandEmail",e.target.value)} 
                          placeholder="Enter Email Address" />
                      </Grid>

                      <Grid item md={6} xs={6}>
                        <label>TCS Commission</label>
                        <TextField startIcon={<FaPercentage/>} fullWidth size="small" type="number"   value={_merchant?.tcsCommission} onChange={(e)=>update("tcsCommission",e.target.value)} 
                          placeholder="Enter TCS Commission " />
                      </Grid>
                      {_merchant.merchantType === 1 && (
                        <Grid item md={6} xs={6}>
                        <label>Shipping Rate</label>
                        <TextField fullWidth size="small" type="number"   value={_merchant?.shippingFee} onChange={(e)=>update("shippingFee",e.target.value)} 
                          placeholder="Enter shipping rate " />
                      </Grid>
                      )}
                      </Grid>
                      
                      <h4 className="space-top">Payment Address</h4>
                      <Grid container  columnSpacing={3} rowSpacing={3}>
                      <Grid item md={6} xs={6}>
                        <label className='space-top'>Street</label>
                        <TextField fullWidth size="small" type="text"   value={_merchant?.street} onChange={(e)=>update("street",e.target.value)} 
                          placeholder="Enter Street name" />
                          {errors.Street &&  <p className="error">Street is required</p>}
                      </Grid>

                      <Grid item md={6} xs={6}>
                        <label className='space-top'>City</label>
                        <TextField fullWidth size="small" type="text"   value={_merchant?.city} onChange={(e)=>update("city",e.target.value)} 
                          placeholder="Enter email address" />
                          {errors.city &&  <p className="error">City is required</p>}
                      </Grid>

                      <Grid item md={6} xs={6}>
                        <label className='space-top'>Country Code</label>
                        <TextField fullWidth size="small" type="text"   value={_merchant?.countryCode} onChange={(e)=>update("countryCode",e.target.value)} 
                          placeholder="Enter Country Code" />
                          {errors.CountryCode &&  <p className="error">Country Code is required</p>}
                      </Grid>

                      <Grid item md={6} xs={6}>
                        <label className='space-top'>Postal Code</label>
                        <TextField fullWidth size="small" type="text"   value={_merchant?.postalCode} onChange={(e)=>update("postalCode",e.target.value)} 
                          placeholder="Enter Postal Code" />
                          {errors.PostalCode &&  <p className="error">Postal Code is required</p>}
                      </Grid>

                      <Grid item md={6} xs={6}>
                        <label className='space-top'>{isTabletOrMobile?"State Code":"State Or Province Code"}</label>
                        <TextField fullWidth size="small" type="text"   value={_merchant?.stateOrProvinceCode} onChange={(e)=>update("stateOrProvinceCode",e.target.value)} 
                          placeholder="Enter State Or Province Code" />
                          {errors.StateOrProvinceCode &&  <p className="error">State Or Province Code is required</p>}
                      </Grid>
                      </Grid>
                      <h4 className="space-top">Operational Address</h4>
                      <Grid container  columnSpacing={3} rowSpacing={3}>
                      <Grid item md={6} xs={6}>
                        <label className='space-top'>Street</label>
                        <TextField fullWidth size="small" type="text"   value={_merchant?.street2} onChange={(e)=>update("street2",e.target.value)} 
                          placeholder="Enter Street name" />
                          {errors.Street2 &&  <p className="error">Street is required</p>}
                      </Grid>

                      <Grid item md={6} xs={6}>
                        <label className='space-top'>City</label>
                        <TextField fullWidth size="small" type="text"   value={_merchant?.city2} onChange={(e)=>update("city2",e.target.value)} 
                          placeholder="Enter email address" />
                          {errors.City2 &&  <p className="error">City is required</p>}
                      </Grid>

                      <Grid item md={6} xs={6}>
                        <label className='space-top'>Country Code</label>
                        <TextField fullWidth size="small" type="text"   value={_merchant?.countryCode2} onChange={(e)=>update("countryCode2",e.target.value)} 
                          placeholder="Enter Country Code" />
                          {errors.CountryCode2 &&  <p className="error">Country Code is required</p>}
                      </Grid>

                      <Grid item md={6} xs={6}>
                        <label className='space-top'>Postal Code</label>
                        <TextField fullWidth size="small" type="text"   value={_merchant?.postalCode2} onChange={(e)=>update("postalCode2",e.target.value)} 
                          placeholder="Enter Postal Code" />
                          {errors.PostalCode2 &&  <p className="error">Postal Code is required</p>}
                      </Grid>

                      <Grid item md={6} xs={6}>
                        <label className='space-top'>{isTabletOrMobile?"State Code":"State Or Province Code"}</label>
                        <TextField fullWidth size="small" type="text"   value={_merchant?.stateOrProvinceCode2} onChange={(e)=>update("stateOrProvinceCode2",e.target.value)} 
                          placeholder="Enter State Or Province Code" />
                          {errors.StateOrProvinceCode2 &&  <p className="error">State Or Province Code is required</p>}
                      </Grid>

                      {/* <Grid item md={12} xs={12}>
                        <label className='space-top'>Operating Address</label>
                        <TextField fullWidth rows={2} size="small" type="text"   value={_merchant?.OperatingAddress} onChange={(e)=>update("OperatingAddress",e.target.value)} 
                          placeholder="Enter Operating Address" />
                          {errors.OperatingAddress &&  <p className="error">Operating Address is required</p>}
                      </Grid> */}

                      <Grid item md={6} xs={6}>
                          <label className='space-top'>Catalogue URL</label>
                          <TextField fullWidth size="small" type="text"  value={_merchant?.catelogUrl} onChange={(e)=>update("catelogUrl",e.target.value)} 
                            placeholder="Catalogue URL (Optional)" />
                        </Grid>

                        <Grid item md={6} xs={6}>
                          <label className='space-top'>Year of Business</label>
                          <TextField fullWidth size="small" type="text"  value={_merchant?.yearOfBusiness} onChange={(e)=>update("yearOfBusiness",e.target.value)} 
                            placeholder="Year of Business (Optional)" />
                        </Grid>

                      </Grid>
                      
                      <div className='push-right space-top'>
                        <Button
                        startIcon={ isLoading? <Spinner
                          size={20}
                          color="red"
                          loading={isLoading}
                          // style={{ marginTop: marginTop }}
                      />:<FaEdit sx={{color:'white'}}/>} 
                        type="submit" variant="contained"  >
                            Update Merchant
                        </Button>
                      </div>
                      
                      </form>
                      <div className='push-left space-top'>
                      <SecondaryButton
                        text={"UPLOAD CSV"}
                        icon
                        className="blackSecBtn"
                        isLoading={isLoading}
                        color={"#fff"}
                        type={2}
                        onClick={() => {
                          videoInputRef.current.click();
                        }}
                      />
                      </div>
                      <input
            ref={videoInputRef}
            type="file"
            accept=".csv"
            onChange={async (e) => {
              if (!e.target.files) return;
              const fileList = e.target.files;
              const formData = new FormData();
              formData.append("files", fileList[0]);
              formData.append("vendor", _merchant?.brandName);
              console.log("vendor: ", _merchant?.brandName);
              try {
                setIsLoading(true);
                const response = await apiPost(UPLOAD_VENDORFORMAT_CSV, formData, {
                  "Content-Type": "multipart/form-data",
                });
                toast.success("Csv Uploaded Successfully");
                setIsLoading(false);
                videoInputRef.current.value = null;
                
               
              } catch (error) {
                videoInputRef.current.value = null;
                setIsLoading(false);
                toast.error(error.message);
              }
            }}
            style={{ display: "none" }}
          />
                    </div>
            </Paper>
        </div>
        </div>
    )
  }

  function ViewMiscModal_() {
    const data=miscPayments?.filter(x=>x.vendor==viewMiscModal?.name)
     return (
         <Modal style={{ width: '100%', overflowX: 'auto', overflowY: 'auto',maxHeight:'800px'}}
         open={viewMiscModal!=null} showCloseIcon={true} center onClose={()=>setViewMiscModal(null)}>
             
                 <div className=''>
                   <div className="bold lg space-bottom2">Misc Payments for {viewMiscModal?.name}</div>

                   <Paper>
             {data?.length>0 ?<TableContainer sx={{ overflowX: "auto"}}>
                <Table >
                <TableHead className='tableHead' >
                  <TableRow>
                    <TableCell><span className=' bold'>Payment Name</span></TableCell>
                    <TableCell><span className=' bold'>Amount</span></TableCell>
                    <TableCell><span className=' bold'>Date</span></TableCell>
                  </TableRow>
                </TableHead>
                  <TableBody>
                    {data?.map((d,index)=>{
                      return(
                        <TableRow key={index}>
                          <TableCell><span>{d.name}</span> </TableCell>
                          <TableCell><span>{moneyFormat(d.amount)}</span></TableCell>
                          <TableCell><span>{moment(d.createdAt).format('Do MMMM')}</span></TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
              </Table>
              </TableContainer>
              :
              <div className="padding ">
                  No Misc payments record found for this year
              </div>
             }
            </Paper>
 
                
                
                 </div>
         </Modal>
     )
   }


  function ConfirmationModal() {
   const send =async (otherPaymentChanel = null)=>{
    if(isLoading) return;
    
    setIsLoading(true);
    const data= otherPaymentChanel ? {
      Name:confirmationModal?.name,
      PaymentChannel:otherPaymentChanel
    }:{
      Name:confirmationModal?.name,
    }
    try {
      const res = await apiPost(PayVendor, data );
      if (res) {
          AnalyticsService.logEvent("PENDING_PAYMENT_SUCCESSFULLY");
          toast.success("Pending Payments has been sent successfully");
          await getUserPaymentReports();
          setConfirmationModal(null)
      }
    } catch (error) {
      console.log(error);
      toast.error("An error occurred while paying the merchant");
    };
    setIsLoading(false);
   }
    return (
        <Modal style={{ width: '100%', overflowX: 'auto', overflowY: 'auto'}}
        open={confirmationModal!=null} showCloseIcon={true} center onClose={()=>setConfirmationModal(null)}>
            
                <div className='padding-x'>
                  <div className="bold lg space-bottom2">Settlement Confirmation</div>
                  <div>Are you sure you want to settle {confirmationModal?.name} the sum of {moneyFormat(getPendingPayments(confirmationModal?.id))} before the next due date?</div>

               
                <form  className="space-top">
                    <div className='push-right'>
                      <Stack direction={'row'} spacing={2}>
                        <Button variant="outlined" onClick={()=>setConfirmationModal(null)}>
                          No, Cancel
                        </Button>
                      <Button onClick={()=>send()}
                        startIcon={ isLoading? <Spinner
                        size={20}
                        color="red"
                        loading={isLoading}
                        // style={{ marginTop: marginTop }}
                      />:<BiSend sx={{color:'white'}}/>} 
                     variant='contained' >Yes, Initiate Via Stripe</Button>
                     <Button onClick={()=>send("other")}
                        startIcon={ isLoading? <Spinner
                        size={20}
                        color="red"
                        loading={isLoading}
                        // style={{ marginTop: marginTop }}
                      />:<BiSend sx={{color:'white'}}/>} 
                     variant='contained' >Yes, but via Other Channel</Button>
                      </Stack>
                   
                    </div>
                </form>

                </div>
        </Modal>
    )
  }

  function ConfirmationMiscModal() {
    const onSubmit =async (d)=>{
     setIsLoading(true);
     const data={
       Name:d?.name,
       Vendor:confirmationMiscModal?.name,
       Amount:d?.amount,
     }
     if(data.Amount<=250) {
        try {
          const res = await apiPost(PayMiscVendor, data );
          if (res) {
              AnalyticsService.logEvent("MISC_PAYMENT_SUCCESSFULLY");
              toast.success("Misc payment has been sent successfully");
              await getUserPaymentReports();
              await getVendorMiscPayments();
              setConfirmationMiscModal(null)
          }
        } catch (error) {
          console.log(error);
          toast.error("An error occurred while paying the merchant");
        };
      }else{
        toast.error("Amount exceed allowed payout");
      }
     setIsLoading(false);
    }
     return (
         <Modal style={{ width: '100%', overflowX: 'auto', overflowY: 'auto'}}
         open={confirmationMiscModal!=null} showCloseIcon={true} center onClose={()=>setConfirmationMiscModal(null)}>
             
                 <div className='padding-x'>
                 <div className="bold lg space-bottom2">Settle Misc Payment</div>
                 <form onSubmit={handleSubmit(onSubmit)} className="space-top">
                 <Grid container columnSpacing={2} rowSpacing={2}>
                    <Grid item md={12} xs={12}>
                      <label>Payment Description</label>
                      <TextField fullWidth size="small" type="text"  {...register("name")}
                        placeholder="Enter Payment Description" />
                        {errors.name &&  <p className="error">Payment description is required</p>}
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <label>Amount</label>
                      <TextField 
                       placeholder="Enter Payout Amount"
                        InputProps={{ 
                          inputProps: { min: 1, max: 250, step: 0.01 },
                          startAdornment:(
                            <InputAdornment position="start">
                             <FaPoundSign sx={{color: "#8D0C1"}}/>
                            </InputAdornment>)
                        }}
                        {...register("amount")}
                           fullWidth size="small" type="number"  />
                    </Grid>
                    
                  </Grid>
                     <div className='push-right space-top'>
                       <Stack direction={'row'} spacing={2}>
                         <Button variant="outlined" onClick={()=>setConfirmationMiscModal(null)}>
                           Close
                         </Button>
                       <Button type="submit"
                         startIcon={ isLoading? <Spinner
                         size={20}
                         color="red"
                         loading={isLoading}
                         // style={{ marginTop: marginTop }}
                       />:<BiSend sx={{color:'white'}}/>} 
                      variant='contained' >Initiate Payout</Button>
                       </Stack>
                    
                     </div>
                 </form>
 
                 </div>
         </Modal>
     )
   }
 

  

}

export default Merchants;